import initialState from "./initialState";

export function ManageUOMReducer(
  state = initialState.ManageUOMFormValues,
  action
) {
  switch (action.type) {
    case "MANAGE_UOM_SET":
      return action.payload;
    default:
      return state;
  }
}
